export default {
    general: {
        add:            'Hinzufügen',
        edit:           'Bearbeiten',
        delete:         'Löschen',
        cancel:         'Abbrechen',
        save:           'Speichern',
        confirm:        'Bestätigen',
        confirm_action: 'Aktion bestätigen',
        sign_out:       'Abmelden',
        more_info:      'Weitere Informationen',
        name:           'Name',
        refresh:        'Aktualisieren',
        actions:        'Aktionen',
        status:         'Status',
        details:        'Details',
        type:           'Typ',
        overview:       'Übersicht',
        settings:       'Einstellungen',
    },
    brand: {
        product_name: 'NervusEye',
        product_line: 'MONITOR',
        vendor:       'by iT TEAM d.o.o.',
        tagline:      'Netzwerk-Betriebsmanagement',
    },
    // Short labels for the navigation row; nav.* stays the full section name
    nav_short: {
        dashboard:     'Übersicht',
        devices:       'Geräte',
        topology:      'Topologie',
        ipam:          'IPAM',
        documentation: 'Doku',
        security:      'Sicherheit',
        syslog:        'Syslog',
        events:        'Ereignisse',
        tools:         'Tools',
        sla:           'SLA',
        templates:     'Vorlagen',
        users:         'Benutzer',
        settings:      'Einstellungen',
        about:         'Info',
    },
    nav: {
        dashboard:      'Dashboard',
        devices:        'Geräte & Struktur',
        topology:       'Netzwerktopologie',
        ipam:           'IPAM & Inventar',
        security:       'Port-Sicherheit & Rogue-Erkennung',
        syslog:         'Syslog & SNMP-Traps',
        events:         'Ereignisse & Ausfälle',
        sensors:        'Sensoren',
        administration: 'Administration',
        templates:      'Vorlagen',
        users:          'Benutzerverwaltung',
        settings:       'Globale Einstellungen',
        changelog:      'Änderungsprotokoll',
        about:          'Über & Hilfe',
    },
    common: {
        cancel: 'Abbrechen',
        close:  'Schließen',
    },
    languages: {
        en:              'English',
        hr:              'Hrvatski',
        sl:              'Slovenščina',
        de:              'Deutsch',
        fr:              'Français',
        change_language: 'Sprache ändern',
    },
    status: {
        up:           'Online (UP)',
        down:         'Offline (DOWN)',
        warning:      'Warnung',
        acknowledged: 'Bestätigt',
        paused:       'Pausiert',
        unknown:      'Unbekannt',
    },
    dashboard: {
        title:                'Betriebs-Dashboard',
        subtitle:             'Echtzeit-Netzwerktelemeterie und Infrastruktur-Status',
        total_devices:        'Geräte insgesamt',
        online_devices:       'Online-Geräte',
        warning_devices:      'Warnung / Eingeschränkt',
        offline_devices:      'Offline / Kritisch',
        total_sensors:        'Aktive Sensoren',
        network_health:       'Netzwerkzustand',
        all_systems_ok:       'Alle überwachten Geräte und Sensoren sind betriebsbereit.',
        active_alerts:        'Aktive Warnungen & Ausfälle',
        active_alerts_desc:   'Geräte und Sensoren, die Aufmerksamkeit erfordern',
        recent_devices:       'Überwachte Infrastrukturgeräte',
        explore_tree:         'Gerätebaum öffnen',
        inspect:              'Prüfen',
        auto_refresh:         'Autom. Aktualisierung',
        arrange_graphs:       'Graphen bearbeiten / anordnen',
        done_arranging:       'Anordnung beenden',
        arrange_hint:         'Anordnungsmodus: Fügen Sie mehrere Telemetrie-Graphen hinzu, ziehen Sie Karten oder nutzen Sie Pfeile zum Sortieren.',
        grid_cols:            'Spalten:',
        save_layout:          'Layout speichern',
        select_sensor_to_add: 'Sensor für Live-Telemetrie auswählen...',
        add_graph:            'Graph hinzufügen',
        layout_saved:         'Telemetrie-Layout gespeichert',
        pause_sensor:         'Sensor pausieren',
        top_metrics_title:    'Leistung & Top-Hosts',
        top_metrics_subtitle: 'Echtzeit-Einblicke nach Ressourcenverbrauch, Datenverkehr und Stabilität',
        widgets_active:       'aktiv',
        top_cpu:              'Höchste CPU-Auslastung',
        top_cpu_desc:         'Geräte mit der höchsten Prozessorauslastung in Prozent',
        top_ram:              'Höchste RAM-Auslastung',
        top_ram_desc:         'Geräte mit dem höchsten Arbeitsspeicherverbrauch',
        top_uptime:           'Verfügbarkeit & Uptime',
        longest_uptime:       'Längste Uptime (Stabilität)',
        recently_rebooted:    'Kürzlich neu gestartet',
        top_ping:             'Höchste Latenz / Ping',
        top_ping_desc:        'Geräte und Dienste mit den höchsten Antwortzeiten (RTT)',
        top_traffic:          'Höchster Netzwerk-Traffic',
        top_port_errors:      'Port-Fehler & Puffer-Verwerfungen',
        no_port_errors:       'Keine Port-Fehler oder Puffer-Verwerfungen erkannt',
        top_bgp:              'BGP-Sitzungen',
        top_temperature:      'Temperatur & Hardware',
        top_storage:          'Top Speicher / Festplatte',
        view_mode_grid:       'Raster',
        view_mode_tabs:       'Tabs',
        customize_widgets:    'Widgets anpassen',
        hosts_ranked:         'gelistete Hosts',
        no_data:              'Keine Daten verfügbar',
    },
    tree: {
        search_placeholder: 'Geräte, IP, Sensoren suchen...',
        filter_all:         'Alle',
        total_items:        'Einträge',
        no_nodes_found:     'Keine passenden Elemente gefunden',
        add_group:          'Gruppe hinzufügen',
        add_folder:         'Ordner hinzufügen',
        add_device:         'Gerät hinzufügen',
        add_sensor:         'Sensor hinzufügen',
        root_title:         'Infrastrukturbaum',
        back_to_tree:       'Zurück zum Baum',
    },
    devices: {
        title:                'Geräte-Explorer',
        add_device:           'Gerät hinzufügen',
        edit_device:          'Gerät bearbeiten',
        delete_device:        'Gerät löschen',
        confirm_delete:       'Möchten Sie dieses Gerät und alle zugehörigen Sensoren wirklich löschen?',
        name:                 'Gerätename',
        name_placeholder:     'z. B. Core-Switch-01',
        hostname_ip:          'Hostname / IP',
        polling_interval:     'Abfrageintervall (s)',
        snmp_enabled:         'SNMP aktivieren',
        snmp_enabled_hint:    'MIB-Metriken abfragen und Schnittstellen automatisch erkennen',
        snmp_version:         'SNMP-Version',
        snmp_port:            'SNMP-Port',
        snmp_community:       'Community-String',
        poll_now:             'Jetzt abfragen',
        polling_started:      'Manuelle Abfrage gestartet',
        snmp_walk:            'SNMP Walk',
        snmp_walk_title:      'SNMP Walk Diagnose',
        run_walk:             'Walk starten',
        walking_mibs:         'OID-Baum wird durchsucht...',
        no_walk_results:      'Keine OID-Ergebnisse zurückgegeben',
        device_details:       'Gerätedetails',
        device_sensors:       'Konfigurierte Sensoren',
        sensors_count:        'Sensoren',
        vendor:               'Hersteller',
        model:                'Modell',
        last_polled:          'Zuletzt abgefragt',
        no_devices_in_folder: 'Keine Geräte in dieser Gruppe/diesem Ordner',
        select_node_hint:     'Wählen Sie links eine Gruppe, einen Ordner oder ein Gerät aus, um Details anzuzeigen.',
    },
    discovery: {
        title:               'Schnittstellenerkennung & Autodiscovery',
        scan_interfaces:     'Schnittstellen scannen',
        run_autodiscovery:   'Vollständige Autodiscovery ausführen',
        select_all:          'Alle auswählen',
        deselect_all:        'Alle abwählen',
        add_selected:        'Ausgewählte als Sensoren hinzufügen',
        scanning_hint:       'Gerät SNMP ifTable / ifXTable wird abgefragt...',
        no_interfaces:       'Keine Schnittstellen gefunden. Stellen Sie sicher, dass SNMP antwortet.',
        description:         'Beschreibung / Alias',
        speed:               'Geschwindigkeit',
        discover_interfaces: 'Schnittstellen erkennen',
    },
    sensors: {
        add_sensor:          'Sensor hinzufügen',
        edit_sensor:         'Sensor bearbeiten',
        edit_sensor_title:   'Sensoreinstellungen bearbeiten',
        type:                'Sensortyp',
        name:                'Sensorname',
        name_placeholder:    'z. B. Ping Latenz',
        interval:            'Intervall (s)',
        enabled:             'Sensor aktiv / aktiviert',
        enabled_hint:        'Wenn deaktiviert, pausiert der Poller die Abfrage dieses Sensors',
        oid:                 'SNMP OID',
        interface_index:     'Schnittstellen-Index',
        last_reading:        'Letzter Messwert',
        last_checked:        'Zuletzt geprüft',
        confirm_delete:      'Möchten Sie diesen Sensor wirklich löschen?',
        no_sensors_assigned: 'Diesem Gerät sind noch keine Sensoren zugewiesen',
    },
    metrics: {
        title:      'Live-Telemetrie & Metriken',
        current:    'Aktuell',
        avg:        'Durchschnitt',
        min:        'Min',
        max:        'Max',
        p95:        '95. Perzentil',
        p95_hint:   '95. Perzentil der 5-Minuten-Werte im gewählten Zeitraum, wie für Traffic-Berichte',
        no_data:    'Keine Messwerte für diesen Zeitraum verfügbar',
    },
    templates: {
        title:                'SNMP-Vorlagen & MIBs',
        subtitle:             'Geräteleistungsvorlagen und Standard-Herstellerprofile',
        add_template:         'Vorlage hinzufügen',
        edit_template:        'Vorlage bearbeiten',
        import_template:      'Vorlagen importieren',
        import_template_hint: 'JSON-Vorlagenstruktur einfügen, um Vorlagen massenhaft zu importieren.',
        import_mib:           'MIB importieren',
        import_mib_hint:      'RFC- oder Hersteller-MIB-Datei hochladen, um OID-Kataloge zu befüllen.',
        export_all:           'Alle exportieren (JSON)',
        export:               'Exportieren',
        search_placeholder:   'Vorlagen nach Name, Hersteller suchen...',
        templates_count:      'Vorlagen',
        no_templates_found:   'Keine SNMP-Vorlagen gefunden',
        template_oids:        'Konfigurierte Vorlagen-OIDs',
        add_oid:              'OID hinzufügen',
        no_oids_added:        'In dieser Vorlage sind noch keine OIDs definiert.',
    },
    users: {
        title:            'Benutzerkonten',
        subtitle:         'Operatorzugriff und Rollenberechtigungen verwalten',
        add_user:         'Benutzer hinzufügen',
        edit_user:        'Benutzer bearbeiten',
        accounts:         'Registrierte Konten',
        username:         'Benutzername',
        role:             'Rolle',
        password:         'Passwort',
        change_password:  'Passwort ändern',
        old_password:     'Aktuelles Passwort',
        new_password:     'Neues Passwort',
        confirm_password: 'Neues Passwort bestätigen',
        no_users_found:   'Keine Benutzerkonten gefunden',
    },
    settings: {
        title:                 'Systemeinstellungen',
        subtitle:              'Globale Konfiguration, Audit-Protokolle und Datenbanksicherung',
        general_tab:           'Allgemein',
        general_preferences:   'Allgemeine Präferenzen',
        appearance:            'Darstellung',
        appearance_info:       'Farbschema dieses Browsers. Seiten, Menüs und Tabs bleiben gleich; nur Farben, Rahmen und Schrift ändern sich.',
        theme_company:         'Unternehmen',
        theme_company_desc:    'NervusEye-Farben: Zinkgrau und Orange',
        theme_classic:         'Klassisch',
        theme_classic_desc:    'Das erste ZeroNMS-Design: Anthrazit, Slate und Blau',
        root_node_name:        'Anzeigename des Stammknotens',
        default_traffic_unit:  'Standard-Bandbreiteneinheit',
        autodiscover_interval:  'Autodiscovery-Intervall',
        autodiscover_hint:      'Wie oft jedes SNMP-Gerät erneut nach neuen Ports, BGP-Peers, PPPoE- und Hardware-Sensoren durchsucht wird. Gelöschte Sensoren werden nicht wieder hinzugefügt.',
        autodiscover_off:       'Aus',
        autodiscover_hourly:    'Stündlich',
        autodiscover_every:     'Alle {n} Stunden',
        audit_logs:            'Audit- & Änderungsprotokolle',
        timestamp:             'Zeitstempel',
        action:                'Ausgeführte Aktion',
        backup_recovery:       'Sicherung & Wiederherstellung',
        console_tab:           'Konsolen-Apps',
        console_downloads:     'Konsole herunterladen',
        console_info:          'Native Desktop-App, die sich gleichzeitig mit mehreren NervusEye MONITOR Servern verbindet und deren Gerätebäume, Alarme und Sensorverlauf anzeigt.',
        console_req_macos:     'macOS 14 Sonoma oder neuer, Apple Silicon und Intel',
        console_req_windows:   'Windows 10 (1809) oder neuer, 64-Bit',
        console_req_android:   'Android 10 oder neuer',
        console_ios_note:      'iPhone und iPad: Die Konsole wird über TestFlight verteilt; bitten Sie Ihren Administrator um eine Einladung.',
        console_build:         'Build',
        console_size:          'Größe',
        console_published:     'Veröffentlicht',
        console_download:      '{file} herunterladen',
        console_unavailable:   'Noch nicht verfügbar',
        console_not_published: 'Auf diesem Server wurde noch kein Installationsprogramm veröffentlicht.',
        console_loading:       'Wird geladen...',
        console_connect:       'Mit diesem Server verbinden',
        console_server_address:'Serveradresse',
        console_step_install:  'Konsole installieren und öffnen.',
        console_step_add:      'Add Server wählen und die obige Serveradresse einfügen.',
        console_step_login:    'Mit Ihrem NervusEye MONITOR Benutzernamen und Passwort anmelden.',
        run_backup:            'Sicherung jetzt starten',
        restore:               'Wiederherstellen',
        notifications_tab:     'Warnungen & Benachrichtigungen',
        notifications_title:   'Alarm- und Benachrichtigungskanäle',
        telegram_title:        'Telegram Alarm-Bot',
        telegram_desc:         'Senden Sie sofortige Push-Benachrichtigungen an Ihren Telegram-Chat oder Ihre IT-Gruppe.',
        telegram_enable:       'Telegram-Alarme aktivieren',
        telegram_bot_token:    'Telegram Bot-Token',
        telegram_token_help:   "Erhalten von {'@'}BotFather auf Telegram (z. B. 123456789:ABCdefGhI...)",
        telegram_chat_id:      'Telegram Chat-ID',
        telegram_chat_help:    'Ziel-Chat- oder Gruppen-ID (z. B. -100123456789)',
        telegram_test_btn:     'Test-Telegram-Alarm senden',
        webhook_title:         'Webhook-Integration',
        webhook_desc:          'Übertragen Sie Alert-JSON an Discord, Slack, Microsoft Teams oder benutzerdefinierte HTTP-Endpunkte.',
        webhook_enable:        'Webhook-Alarme aktivieren',
        webhook_url:           'Webhook-URL-Endpunkt',
        webhook_url_help:      'Eingehende Webhook-URL (z. B. Discord- oder Slack-Webhook)',
        webhook_test_btn:      'Test-Webhook-Alarm senden',
        trigger_rules_title:   'Alarm-Auslöserregeln',
        notify_down:           'Bei Ausfall benachrichtigen (DOWN)',
        notify_down_help:      'Sofortige Warnung senden, wenn Gerät oder Sensor DOWN geht',
        notify_warning:        'Bei Warnung benachrichtigen (WARNING)',
        notify_warning_help:   'Warnung senden, wenn der Warnschwellenwert überschritten wird',
        notify_recovery:       'Bei Wiederherstellung benachrichtigen (RECOVERY)',
        notify_recovery_help:  'Benachrichtigung senden, wenn die Komponente wieder normal läuft',
    },
    events: {
        title:            'Ausfall- & Ereignisverlauf',
        subtitle:         'Chronologisches Protokoll von Netzwerkausfällen, Warnungen und Wiederherstellungen',
        tab:              'Ereignisse',
        total_outages:    'Ausfälle gesamt',
        active_outages:   'Aktive Ausfälle',
        resolved_outages: 'Behobene Vorfälle',
        warnings:         'Warnungsereignisse',
        filter_device:    'Gerät, IP oder Sensor suchen...',
        filter_status:    'Status',
        filter_resolved:  'Zustand',
        all_statuses:     'Alle Status',
        all_states:       'Alle Zustände',
        active_only:      'Nur aktive',
        resolved_only:    'Nur behobene',
        started_at:       'Begonnen am',
        ended_at:         'Beendet am',
        duration:         'Dauer',
        component:        'Komponente / Sensor',
        reason:           'Ursache / Meldung',
        active:           'Aktiver Ausfall',
        resolved:         'Behoben',
        no_events:        'Keine Ausfallereignisse gefunden.',
        ongoing:          'Laufend',
    },
    layout: {
        open_menu:  'Menü öffnen',
        more:       'Mehr',
        close_menu: 'Menü schließen',
    },
    color_mode: {
        switch_to_light: 'Zum hellen Modus wechseln',
        switch_to_dark:  'Zum dunklen Modus wechseln',
    },
    errors: {
        generic_error: 'Ein Fehler ist aufgetreten',
        invalid_data:  'Ungültige Daten',
        not_found:     'Nicht gefunden',
        unauthorized:  'Nicht autorisiert',
        on_add:        'Fehler beim Hinzufügen',
        on_edit:       'Fehler beim Aktualisieren',
    },
    success: {
        add:  'Erfolgreich hinzugefügt',
        edit: 'Erfolgreich aktualisiert',
    },
    validation: {
        required: 'Dieses Feld ist erforderlich',
        email:    'Ungültige E-Mail-Adresse',
    },
    syslog: {
        title:               'Zentraler Syslog & SNMP-Trap Empfänger',
        subtitle:            'Echtzeit UDP 514 Syslog & UDP 162 SNMP-Trap Erfassung, Cisco Mnemonic-Analyse und Sofort-Alarmierung',
        live_Pause:          'Live-Stream aktiv',
        paused:              'Stream pausiert',
        simulate:            'Ereignis / Trap simulieren',
        clear_old:           'Alte Logs bereinigen',
        total_messages:      'Gespeicherte Ereignisse',
        last_24h:            'Ereignisse (Letzte 24h)',
        critical_24h:        'Kritisch / Alarm (24h)',
        warnings_24h:        'Warnungen (24h)',
        syslog_vs_trap:      'Syslog vs. SNMP-Traps',
        top_categories:      'Top-Kategorien:',
        search_placeholder:  'Suche nach Nachricht, Mnemonic (%LINK-3-UPDOWN), IP, Gerät...',
        all_protocols:       'Alle Protokolle',
        all_devices:         'Alle Geräte',
        all_categories:      'Alle Kategorien',
        all_severities:      'Alle Schweregrade',
        Critical_only:       'Nur Kritisch & Fehler (Sev 0-3)',
        warnings_and_up:     'Warnung & höher (Sev 0-4)',
        notifications_and_up:'Hinweis & höher (Sev 0-5)',
        info_and_up:         'Informativ & höher (Sev 0-6)',
        col_time:            'Zeitstempel',
        col_protocol:        'Protokoll',
        col_severity:        'Schweregrad',
        col_device:          'Quellgerät',
        col_category:        'Kategorie',
        col_mnemonic:        'Mnemonic / Trap-OID',
        col_message:         'Ereignismeldung',
        no_messages:         'Keine Syslog- oder SNMP-Trap-Meldungen gefunden.',
        no_messages_hint:    'Senden Sie Syslog an UDP 514 oder SNMP-Traps an UDP 162, oder klicken Sie auf "Ereignis / Trap simulieren".',
        showing_count:       'Zeige {shown} von {total} Meldungen',
        simulate_desc:       'Simulieren Sie ein Syslog-Paket oder eine SNMP-Trap-PDU zum Testen der Analyse und Alarmierung.',
        preset_template:     'Ereignisvorlage',
        protocol:            'Protokoll',
        source_device:       'Quellgerät',
        custom_ip:           'Benutzerdefinierte IP',
        source_ip:           'Quell-IP-Adresse',
        hostname:            'Hostname',
        severity:            'Schweregrad',
        category:            'Kategorie',
        mnemonic:            'Cisco Mnemonic / Kennung',
        interface_opt:       'Schnittstelle (Optional)',
        message_body:        'Nachrichtentext',
        send_simulation:     'Simuliertes Ereignis senden',
        sim_sent_title:      'Ereignis gesendet',
        sim_sent_desc:       'Simulierte Syslog/Trap-Nachricht wurde verarbeitet.',
        cleared_title:       'Protokolle bereinigt',
        cleared_desc:        '{count} alte Einträge entfernt.',
        detail_title:        'Ereignis- & Paketdetails',
        trap_oid:            'SNMP Trap OID',
        raw_payload:         'Rohdaten (Raw Payload / VarBinds)',
    },
    topology: {
        title:               'Netzwerktopologie',
        subtitle:            'Automatisch erkannte L2/L3-Netzwerktopologie & Switch-Port-Verkabelung über CDP, LLDP und SNMP',
        nodes_count:         '{count} Knoten',
        links_count:         '{count} aktive Verbindungen',
        ports_count:         '{count} belegte Ports',
        view_mode:           'Kartenansicht:',
        view_wiring:         'Schaltplan: Switch → MAC → Gerät',
        view_chassis:        'Switch-Frontblende (Faceplate)',
        view_ports:          'Switch- & Port-Verkabelung',
        view_graph:          'Interaktiver Netzwerk-Graph',
        view_matrix:         'Port-Patch-Matrix',
        filter_all:          'Alle',
        filter_switches:     'Switches',
        filter_routers:      'Router',
        filter_managed:      'Überwacht',
        search_placeholder:  'Knoten, Ports, Beschreibungen oder IPs filtern...',
        reset_layout:        'Layout zurücksetzen',
        refresh_scan:        'Topologie scannen',
        scanning:            'Scanne CDP/LLDP-Nachbarn & Port-Telemetrie...',
        legend_title:        'Topologie-Legende',
        legend_monitored:    'Überwacht (SNMP UP)',
        legend_external:     'CDP/LLDP-Nachbar',
        legend_offline:      'Warnung / Offline',
        status_label:        'Knotenstatus',
        status_monitored:    'Überwachtes Gerät',
        status_external:     'Erkannter Nachbar (CDP/LLDP)',
        type_label:          'Gerätetyp',
        vendor_model:        'Hersteller & Modell',
        open_in_devices:     'In Geräten öffnen',
        connected_links:     'Verbundene Links & Ports ({count})',
        local_port:          'Lokaler Port',
        remote_port:         'Remote-Port',
        port_alias:          'Port-Beschreibung / Alias',
        connected_device:    'Verbundenes Gerät / Gegenstelle',
        protocol:            'Protokoll',
        speed_traffic:       'Geschwindigkeit & Live-Traffic',
        switch_chassis_desc: 'Aktive physische & LAG-Ports mit CDP/LLDP-Nachbarn und SNMP-Schnittstellenbeschreibungen',
        show_all_ports:      'Alle aktiven beschrifteten Ports',
        show_cdp_only:       'Nur CDP / LLDP Nachbarn',
        no_links_found:      'Keine Topologie-Links für den aktuellen Filter gefunden.',
        unidentified_peer:   'Aktiver Link',
        external_peers:      'Erkannte verbundene Geräte & Endpunkte',
    },
    sensor_action: {
        ack_title:           'Sensor-Alarm bestätigen (ACK)',
        ack_title_edit:      'Sensor-Bestätigung bearbeiten (ACK)',
        pause_title:         'Sensor-Abfrage pausieren',
        resume_title:        'Sensor-Abfrage fortsetzen',
        recorded_operator:   'Erfasster Benutzer',
        logged_in:           'Angemeldet',
        comment_label_ack:   'Kommentar / Bestätigungsgrund',
        comment_label_pause: 'Grund für Pause / Wartung',
        visible_to_team:     'Für das gesamte Team sichtbar',
        comment_ph_ack:      'z.B. Wartungsarbeiten am Link, ISP-Störung gemeldet, Hardwaretausch...',
        comment_ph_pause:    'z.B. Geplante Wartung, vorübergehend für Labortests deaktiviert...',
        btn_clear_ack:       'ACK aufheben',
        btn_ack:             'Sensor bestätigen (ACK)',
        btn_update_comment:  'Kommentar speichern',
        btn_pause:           'Abfrage pausieren',
        btn_resume:          'Abfrage fortsetzen',
        btn_resume_now:      'Jetzt fortsetzen',
        btn_acked:           'Bestätigt',
        acked_by:            'Bestätigt von',
        paused_by:           'Pausiert von',
        no_comment:          'Keine Anmerkung',
        banner_acked:        'Sensor-Alarm bestätigt',
        banner_paused:       'Sensor-Abfrage pausiert',
        edit_comment:        'Kommentar bearbeiten',
        clear_ack:           'ACK aufheben',
        success_ack:         'Sensor-Alarm wurde bestätigt',
        success_unack:       'Sensor-Bestätigung wurde aufgehoben',
        success_pause:       'Sensor-Abfrage wurde pausiert',
        success_resume:      'Sensor-Abfrage wurde fortgesetzt',
        presets: {
            maintenance:       'Geplante Netzwerkwartung aktiv',
            isp_outage:        'ISP-Störung - Ticket beim Provider eröffnet',
            hardware_replace:  'Warten auf Hardware- / SFP-Austausch',
            known_issue:       'Bekanntes Problem - Analyse läuft',
            investigating:     'Temporäre Störung - wird überwacht',
            pause_maintenance: 'Geplante Gerätewartung',
            pause_testing:     'Vorübergehend für Tests pausiert',
            pause_disabled:    'Gerät bis auf Weiteres offline',
            pause_customer:    'Kundenanschluss stillgelegt',
            pause_monitoring:  'Überwachung vorübergehend pausiert',
        },
    },
    inspector: {
        title_up:           'Fehlerfreie Sensoren & Geräte (UP)',
        title_down:         'Kritische Sensoren & Ausfälle (DOWN)',
        title_warning:      'Warnungen & beeinträchtigte Sensoren (WARN)',
        title_ack:          'Bestätigte Sensoren (ACK)',
        title_paused:       'Pausierte Sensoren / Wartung (PAUSED)',
        title_unknown:      'Unbekannte / Ungeprüfte Sensoren (UNKNOWN)',
        subtitle:           'Detaillierte Sensorbeschreibungen, Telemetriemesswerte, Bestätigungen (ACK) und Pausengründe.',
        matching:           'Treffer',
        close_filter:       'Filter schließen',
        search_placeholder: 'Sensor, Gerät, Kommentar oder Benutzer suchen...',
        no_matching:        'Derzeit entsprechen keine Sensoren oder Geräte dem Status',
        th_status:          'Status',
        th_device:          'Gerät',
        th_sensor_name:     'Sensor- / Knotenname',
        th_type:            'Typ',
        th_detail:          'Sensorbeschreibung & ACK / Pause-Details',
        th_reading:         'Aktueller Messwert',
        th_last_checked:    'Zuletzt geprüft',
        th_actions:         'Aktionen',
        inspect:            'Prüfen',
        clone_sensor:       'Sensor duplizieren',
        showing:            'Angezeigt',
        of:                 'von',
        specs_title:        'Sensorkonfiguration & Grenzwerte',
        sensor_id:          'Sensor-ID',
        check_interval:     'Prüfintervall',
        alarm_thresholds:   'Alarmgrenzwerte',
        edit_thresholds:    'Grenzwerte / Sensor bearbeiten',
    },
    bgp: {
        session_uptime:        'Sitzungs-Laufzeit (Uptime)',
        remote_as:             'Remote AS / Peer',
        asn_lookup_title:      'Autonomes System (ASN) Abfrage',
        asn_lookup_btn:        'AS Abfrage',
        asn_input_placeholder: 'AS-Nummer eingeben (z.B. 13335, AS5448, 65400)...',
        quick_presets:         'Schnellauswahl:',
        querying_whois:        'WHOIS & RIPE Stat Einträge werden abgerufen...',
        private_as:            'Privates AS',
        public_as:             'Öffentliches AS',
        network_type:          'Netzwerktyp',
        description:           'Beschreibung',
        external_tools:        'Externe BGP Looking Glass & Tools',
        lookup_as:             'AS prüfen',
        enter_valid_as:        'Bitte geben Sie eine gültige AS-Nummer ein',
        asn_not_found:         'AS-Informationen konnten nicht aufgelöst werden',
        network_error:         'Netzwerkfehler bei der ASN-Abfrage',
        resolving:             'Wird aufgelöst...',
        established:           'Hergestellt',
    },
    scanner: {
        port_scan_title:      'Port-Scanner & Dienste',
        port_scan_hint:       'Offene Dienste automatisch erkennen (SSH, HTTP, DNS, Winbox, BGP) und Sensorgruppe erstellen',
        profile:              'Scan-Profil',
        profile_well_known:   'Bekannte Dienste (~75 Ports, <1s)',
        profile_common_1024:  'Standard-Ports 1-1024 (~1s)',
        profile_top_1000:     'Top 1000 Ports (~2s)',
        scan_now:             'Jetzt scannen',
        enter_ip_first:       'Bitte vor dem Scan eine IP-Adresse eingeben',
        scan_failed:          'Port-Scan fehlgeschlagen',
        found_ports:          '{count} offene Ports gefunden ({duration} ms)',
        no_open_ports:        'Keine offenen Ports gefunden',
        open_ports_tab:       'Offene Ports & Dienste',
        open_ports_title:     'Offene Ports & Netzwerkdienste',
        rescan_now:           'Ports scannen',
        add_all_as_sensors:   'Alle als Sensoren hinzufügen',
        open_ports_count:     'Offene Ports',
        scan_speed:           'Letzte Scan-Dauer',
        target_ip:            'Ziel-IP-Adresse',
        active_sensors:       'Aktive Port-Sensoren',
        search_placeholder:   'Nach Port, Protokoll oder Dienst suchen...',
        empty_hint:           'Keine offenen Ports für dieses Gerät erfasst. Schnellen Port-Scan starten.',
        start_scan:           'Port-Scan starten',
        col_port:             'Port / Protokoll',
        col_service:          'Dienst',
        col_description:      'Dienstbeschreibung',
        col_latency:          'Latenz',
        col_status:           'Status',
        col_action:           'Baum-Sensor',
        sensor_active:        'Sensor aktiv',
        create_sensor:        'Sensor hinzufügen',
        scan_completed:       '{count} offene Ports in {duration}ms gefunden',
    },
}


